"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = __importDefault(require("../base/model"));
const token_schema_1 = require("./token.schema");
const utils_1 = require("../utils");
class Token extends model_1.default {
    isKeyAllowed(key) {
        return key !== 'refreshTokenID';
    }
    //If delete fails just set ttl to now
    delete() {
        return super.delete().catch(() => {
            this.expiry = (0, utils_1.ttl)(new Date());
            return super.commit();
        });
    }
    isExpired() {
        return this.expiry ? this.expiry * 1000 < Date.now() : false;
    }
    flatten() {
        return {
            username: this.username,
            tokenID: this.ID,
            permissions: (this.permissions || []).join(','),
            userID: this.userID,
            companyID: this.companyID,
            instanceID: this.instanceID,
            name: this.name,
            hierarchyStructure: this.hierarchyStructure
        };
    }
}
exports.default = Token;
Token.schema = token_schema_1.TokenSchema;
